'use strict';
import * as $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData from "./app.components.-App-Main-Modal$-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_AppMainModal$Data$OnNetworkError(err, definedAt) {
  this.Lapp_components_AppMainModal$Data$OnNetworkError__f_err = null;
  this.Lapp_components_AppMainModal$Data$OnNetworkError__f_definedAt = null;
  this.Lapp_components_AppMainModal$Data$OnNetworkError__f_err = err;
  this.Lapp_components_AppMainModal$Data$OnNetworkError__f_definedAt = definedAt;
}
export { $c_Lapp_components_AppMainModal$Data$OnNetworkError as $c_Lapp_components_AppMainModal$Data$OnNetworkError };
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype = new $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData.$h_Lapp_components_AppMainModal$Data();
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.constructor = $c_Lapp_components_AppMainModal$Data$OnNetworkError;
/** @constructor */
function $h_Lapp_components_AppMainModal$Data$OnNetworkError() {
}
export { $h_Lapp_components_AppMainModal$Data$OnNetworkError as $h_Lapp_components_AppMainModal$Data$OnNetworkError };
$h_Lapp_components_AppMainModal$Data$OnNetworkError.prototype = $c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype;
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 806216320, true);
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_components_AppMainModal$Data$OnNetworkError)) {
    var x = this.Lapp_components_AppMainModal$Data$OnNetworkError__f_err;
    var x$2 = x$0.Lapp_components_AppMainModal$Data$OnNetworkError__f_err;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.productPrefix__T = (function() {
  return "OnNetworkError";
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_components_AppMainModal$Data$OnNetworkError__f_err;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$OnNetworkError.prototype.definedAt__Lframework_sourcecode_DefinedAt = (function() {
  return this.Lapp_components_AppMainModal$Data$OnNetworkError__f_definedAt;
});
function $isArrayOf_Lapp_components_AppMainModal$Data$OnNetworkError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_components_AppMainModal$Data$OnNetworkError)));
}
export { $isArrayOf_Lapp_components_AppMainModal$Data$OnNetworkError as $isArrayOf_Lapp_components_AppMainModal$Data$OnNetworkError };
var $d_Lapp_components_AppMainModal$Data$OnNetworkError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_components_AppMainModal$Data$OnNetworkError, "app.components.AppMainModal$Data$OnNetworkError", ({
  Lapp_components_AppMainModal$Data$OnNetworkError: 1,
  Lapp_components_AppMainModal$Data: 1,
  Lframework_components_FrameworkMainModal$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_components_AppMainModal$Data$OnNetworkError as $d_Lapp_components_AppMainModal$Data$OnNetworkError };
//# sourceMappingURL=app.components.-App-Main-Modal$-Data$-On-Network-Error.js.map
